import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@pc/components/ui/skeleton';
import { Fragment } from 'react';
function BJRankingLoading() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h2 className="flex-1 text-left font-medium text-[15px] leading-[21px] tracking-[-0.5px]">{"BJ\uB7AD\uD0B9"}</h2>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex w-full items-center justify-between px-[23px]">{t0}<div className="flex items-center py-px"><button type="button" disabled={true} className="px-[10px] text-center font-medium text-[13px] text-colorFg03 leading-[19px] tracking-[-0.5px]">{"\uAC1C\uC778"}</button><div className="h-[16px] w-px bg-borderBg07" /><button type="button" disabled={true} className="pl-[10px] text-center font-medium text-[13px] text-colorFg03 leading-[19px] tracking-[-0.5px]">{"\uC804\uCCB4"}</button></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = Array.from({
      length: 5
    })?.map(_temp);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="border-borderBg01 border-b pt-[17px] pb-[20px]">{t1}<div className="flex flex-col gap-[10px] px-[8px] pt-[5px]">{t2}<Skeleton className="flex h-[26px] w-full items-center gap-[30px] px-[10px] text-[15px] tracking-[-0.5px]"><Skeleton className="h-[5px] w-[8px]" /><Skeleton className="h-[21px] w-[85px]" /></Skeleton></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp(_, idx) {
  return <Fragment key={`${String(idx)}rank`}><div className="flex h-[50px] w-full items-center gap-6 rounded-[10px] px-[17px] text-[15px] leading-[21px] tracking-[-0.5px]"><Skeleton className="h-6 w-6 overflow-hidden rounded-full border border-transparent"><Skeleton className="h-full w-full rounded-full bg-[hsla(0,0%,100%,0.06)] object-cover" /></Skeleton><Skeleton className="flex-1 overflow-hidden"><span className="inline-flex max-w-[100px] overflow-hidden align-top"><Skeleton className="overflow-hidden truncate" /></span></Skeleton></div></Fragment>;
}
export default BJRankingLoading;